/* TextClick.tsx
   Version: 1.1.0
   Date: 2021-05-28
*/

// eslint-disable-next-line
import * as React from 'react';
import PropTypes from 'prop-types';

export interface TextClickProps {
    children?: React.ReactNode,
    className?: string;
    name: string;
    index?: number;
    rowindex?: number;
    colindex?: number;
    onClick: (event: React.MouseEvent<HTMLSpanElement>) => void;
}

const TextClick: React.FC<TextClickProps> = (props): JSX.Element => {

    TextClick.propTypes = {
        children: PropTypes.node,
        className: PropTypes.string,
        name: PropTypes.string.isRequired,
        index: PropTypes.number,
        rowindex: PropTypes.number,
        colindex: PropTypes.number,
        onClick: PropTypes.func.isRequired,
    }
    
    return(
        <span 
            className={props.className ?? 'basic-text-click'} 
            data-name={props.name} 
            data-index={props.index}
            data-rowindex={props.rowindex}
            data-colindex={props.colindex}
            onClick={props.onClick}>{props.children}
        </span>
    );

}

export default TextClick;
